import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import Form from "src/components/Form"

const AmountInputField = ({
  id,
  disabled = false,
  registeredField,
  amountType,
  hasErrors = false,
}) => {
  const { currencySymbol } = useMarina()

  const getIconAndPosition = () => {
    if (amountType === "percent") {
      return { icon: "%", position: "right" }
    }
    return { icon: currencySymbol, position: "left" }
  }

  const { icon, position } = getIconAndPosition()

  return (
    <Form.IconTextField
      id={id}
      position={position}
      icon={icon}
      disabled={disabled}
      {...registeredField}
      type="number"
      hasErrors={hasErrors}
    />
  )
}

AmountInputField.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  registeredField: PropTypes.object.isRequired,
  amountType: PropTypes.oneOf(["currency", "percent"]).isRequired,
  disabled: PropTypes.bool,
  hasErrors: PropTypes.bool,
}

export default AmountInputField
